var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyGoNewIcon = function SvgHappyGoNewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoNewIcon_svg__a)",
    fillRule: "evenodd",
    d: "M11.93 7.386a3.693 3.693 0 1 0 0-7.386 3.693 3.693 0 0 0 0 7.386m1.29-4.026.148-.566h-.582a1.24 1.24 0 0 0-.187-.502h.624l.151-.564h-2.732l-.173.687h.76q.256 0 .411.09a.52.52 0 0 1 .243.29h-1.265l-.152.565H11.9a.586.586 0 0 1-.272.36.75.75 0 0 1-.394.093h-.686l.003.5 1.407 1.666h.958v-.04l-1.267-1.527q.415-.074.668-.252.254-.18.371-.458.066-.156.095-.342z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#happyGoNewIcon_svg__b)",
    fillRule: "evenodd",
    d: "M5.34 3.7v-.526a1.62 1.62 0 0 0-.37-1.071 1.2 1.2 0 0 0-.96-.444q-.676 0-1.062.531t-.386 1.496q0 .83.367 1.312t1.003.482q.63 0 1.02-.489.389-.489.389-1.292m2.01 2.427q0 1.845-1.062 2.86Q5.228 10 3.214 10q-1.33 0-2.11-.382V7.895q1.017.596 2.052.596 1.03 0 1.595-.548.566-.547.566-1.486v-.525h-.026Q4.596 7.046 3.24 7.046q-1.26 0-2-.893Q.5 5.259.5 3.756q0-1.684.823-2.675t2.168-.99q1.202 0 1.8.932h.026V.252H7.35z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoNewIcon_svg__a",
    x1: 15.623,
    x2: 8.236,
    y1: 7.386,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "happyGoNewIcon_svg__b",
    x1: 7.349,
    x2: -1.921,
    y1: 10,
    y2: 3.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A5C"
  })))));
};
export default SvgHappyGoNewIcon;